/**
 * List of constants to be used in options code.
 */
export const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';

export const SHOW_SENDER_ON_TOP_IN_LIST_VIEW: string = 'ShowSenderOnTopInListView';
export const SHOW_PREVIEW_TEXT_IN_LIST_VIEW: string = 'ShowPreviewTextInListView';
export const MAIL_LEFT_SWIPE_ACTION: string = 'MailLeftSwipeAction';
export const MAIL_RIGHT_SWIPE_ACTION: string = 'MailRightSwipeAction';

// FocusedInbox
export const IS_FOCUSED_INBOX_ENABLED = 'IsFocusedInboxEnabled';

// Conversation View
export const GLOBAL_LIST_VIEW_TYPE = 'GlobalListViewTypeReact';
export const CONVERSATION_SORT_ORDER = 'ConversationSortOrderReact';

// Sender Image
export const LIST_VIEW_BIT_FLAGS = 'ListViewBitFlags';
export const LIST_VIEW_BIT_TYPE = 'Integer32';

// Search History
export const PEOPLE_HUB_OPTIONS_CONFIGURATION = 'PeopleHubOptions';
export const PEOPLE_HUB_OPTIONS_TYPE = 'String';
export const SEARCH_HISTORY_CONFIGURATION = 'SearchHistory';
export const SEARCH_HISTORY_TYPE = 'StringArray';
export const SOURCE_CLIENT_MINI = 'mini';
